import {Strings} from '@zvne/fe-framework/dist/presentation/language/strings';

const en = {
    liveClusters: 'Live Clusters',
    reality: 'Reality',
    prediction: 'Prediction',
    layers: 'Layers',
    strokes: 'stroke(s)',
    current: 'Current',
    min: 'min'
};

const hr = {
    liveClusters: 'Klasteri uživo',
    reality: 'Stvarnost',
    prediction: 'Predviđanje',
    layers: 'Slojevi',
    strokes: 'udar(a)',
    current: 'Aktualno',
    min: 'min'
};

export const strings: Strings<typeof en> = {en, hr};
